import React from 'react';
import { FaFileAlt, FaImage, FaVolumeUp, FaProjectDiagram, FaChartBar, FaSitemap, FaCube } from 'react-icons/fa';

const TabList = ({ value, onChange }) => {
const tabs = [
    { id: 'text', label: 'Text', icon: <FaFileAlt /> },
];

  return (
    <div className="tab-list-container">
      <div className="tab-list">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-item ${value === tab.id ? 'active' : ''}`}
            onClick={() => onChange(tab.id)}
            aria-selected={value === tab.id}
            role="tab"
          >
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabList;
